import { useContext } from "react";
import LayoutWrapper from "../../../../components/utility/layoutWrapper";
import CreateTaskHeader from "../../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader";
import { AppContext } from "../../../../context/ContextProvider";
import Box from "../../../../components/utility/box";
import { Card, Typography } from "antd";
import styled from "styled-components";

const boxStyle = {
    border: "none",
    padding: "0",
    margin: "0"
};

const cardTitleStyle = {
    fontFamily: "Poppins",
    fontSize: "12px",
    color: "#292929",
    marginBottom: "0"
};

const cardSubtitleStyle = {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "70%",
    color: "#5e6366",
    fontSize: "12px",
    fontFamily: "Nunito Sans",
    margin: "0"
};

const Title = styled("h2")`
    font-size: 14px;
    font-family: Poppins;
    color: #292929;
    margin-top: 20px;
`;

const Subtitle = styled("p")`
    font-size: 12px;
    font-family: Nunito Sans;
    color: #5e6366;
    margin-top: 10px;
`;

export default function FailedControlsDrawer({ data }) {
    const { setOpenRightDrawer } = useContext(AppContext);
    const handelCancel = () => {
        setOpenRightDrawer({
            drawerType: null,
            drawerProps: {
                data: null
            }
        });
    }
    return (
        <LayoutWrapper className="clusterInfo" style={{ padding: "0" }}>
            <CreateTaskHeader buttonContent={"Failed Controls"} onCancel={handelCancel} />
            <div style={{ marginTop: "90px", padding: "0 20px", height: "fit-content", marginBottom: "100px", width: "100%" }}>
                {data?.failedRules?.map((rule) => {
                    return (
                        <div key={rule}>
                            <Title>Name</Title>
                            <Subtitle>{rule.name}</Subtitle>

                            <Title>Paths</Title>

                            {rule?.paths.map((path) => {
                                return (
                                    <Card key={path.resourceID}
                                        style={{
                                            borderRadius: "10px",
                                            padding: "10px",
                                            background: "#fbfbfb",
                                            marginTop: "20px",
                                            // width: "60%"
                                        }}
                                        styles={{
                                            body: {
                                                padding: "0"
                                            }
                                        }}>
                                        <div style={{ marginBottom: "10px" }}>
                                            <Typography.Paragraph style={cardTitleStyle}>resourceID</Typography.Paragraph>
                                            <Typography.Paragraph style={{...cardSubtitleStyle, width: "100%", whiteSpace: "normal", overflow: "auto"}}>{path.resourceID}</Typography.Paragraph>
                                        </div>
                                        <Typography.Paragraph style={cardTitleStyle}>fixPath</Typography.Paragraph>
                                        <div>
                                            <Typography.Paragraph style={cardSubtitleStyle} title={path.fixPath?.path ? path.fixPath.path : "-"}>path: {path.fixPath?.path ? path.fixPath.path : "-"}</Typography.Paragraph>
                                            <Typography.Paragraph style={cardSubtitleStyle} title={path.fixPath?.value ? path.fixPath.value : "-"}>value: {path.fixPath?.value ? path.fixPath.value : "-"}</Typography.Paragraph>
                                        </div>
                                    </Card>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </LayoutWrapper>
    );
}